import { render } from "./ClientCommunication.vue?vue&type=template&id=35059c66&scoped=true"
import script from "./ClientCommunication.vue?vue&type=script&lang=js"
export * from "./ClientCommunication.vue?vue&type=script&lang=js"

import "./ClientCommunication.vue?vue&type=style&index=0&id=35059c66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35059c66"]])

export default __exports__